// Polyfills
import "svgxuse";
import 'element-closest';

import BackToTop from './modules/backToTop'
import FormAnimation from './modules/form-animation'
import ParallaxScroll from "./modules/parallax"
import FullwidthSection from "./modules/fullwidthSection"
import EventFiltersDropdown from "./modules/iederal/eventFiltersDropdown"
import { MainMenu } from "./modules/iederal/mainMenu"
import { MapsPlanRoute } from "./modules/iederal/mapsPlanRoute"
import { TicketModal } from "./modules/iederal/ticket-modal"
import NotificationBar from "./modules/notificationBar"

document.addEventListener("DOMContentLoaded", function() {
  new BackToTop()
  new FullwidthSection()
  new EventFiltersDropdown()
  new MainMenu()
  new MapsPlanRoute()
  new NotificationBar()
  new FormAnimation()
  new ParallaxScroll()
  new TicketModal()
})
